export const FETCH_CERTIFICATION_AUTHORITIES =
  'ipfabric/system/FETCH_CERTIFICATION_AUTHORITIES';
export const DELETE_CA = 'ipfabric/system/DELETE_CA';
export const PATCH_CA = 'ipfabric/system/PATCH_CA';
export const UPLOAD_CA = 'ipfabric/system/UPLOAD_CA';
export const SHOW_UPLOAD = 'ipfabric/system/SHOW_UPLOAD';

export const confirmDeleteCA = 'confirmDeleteCA';
